import { action } from 'mobx';
import HttpClient from 'utils/httpclient';
import { LOADING, LOADED } from 'stores/BaseStore';
import BaseStore from 'stores/BaseStore';

class RouteStore extends BaseStore {
  constructor () {
    super('cms/routes', 'cms/route', {site_model : true});
  }

  @action all (site_id) {
    this.collection.readyState = LOADING;
    this.getCurrentSiteID();
    return (
      HttpClient.get(this.collectionURL, {params: {site_id}})
      .then(action(response => {
        const list = response.data;
        this.collection.objects = list;
        this.collection.count = list.length;
        this.collection.readyState = LOADED;
        return response;
      }))
    );
  }
}

export default new RouteStore();
